var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("body", { staticClass: "container" }, [
      _c("div", { staticClass: "night" }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "bubbles" }, [
        _c("div", { staticClass: "bubble" }, [
          _c("svg", { staticClass: "heart", attrs: { viewBox: "0 0 32 32" } }, [
            _c("title", [_vm._v("heart22")]),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M23.6 2c-3.363 0-6.258 2.736-7.599 5.594-1.342-2.858-4.237-5.594-7.601-5.594-4.637 0-8.4 3.764-8.4 8.401 0 9.433 9.516 11.906 16.001 21.232 6.13-9.268 15.999-12.1 15.999-21.232 0-4.637-3.763-8.401-8.4-8.401z"
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bubble" }, [
          _c("svg", { staticClass: "heart", attrs: { viewBox: "0 0 32 32" } }, [
            _c("title", [_vm._v("heart22")]),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M23.6 2c-3.363 0-6.258 2.736-7.599 5.594-1.342-2.858-4.237-5.594-7.601-5.594-4.637 0-8.4 3.764-8.4 8.401 0 9.433 9.516 11.906 16.001 21.232 6.13-9.268 15.999-12.1 15.999-21.232 0-4.637-3.763-8.401-8.4-8.401z"
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bubble" }, [
          _c("svg", { staticClass: "heart", attrs: { viewBox: "0 0 32 32" } }, [
            _c("title", [_vm._v("heart22")]),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M23.6 2c-3.363 0-6.258 2.736-7.599 5.594-1.342-2.858-4.237-5.594-7.601-5.594-4.637 0-8.4 3.764-8.4 8.401 0 9.433 9.516 11.906 16.001 21.232 6.13-9.268 15.999-12.1 15.999-21.232 0-4.637-3.763-8.401-8.4-8.401z"
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bubble" }, [
          _c("svg", { staticClass: "heart", attrs: { viewBox: "0 0 32 32" } }, [
            _c("title", [_vm._v("heart22")]),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M23.6 2c-3.363 0-6.258 2.736-7.599 5.594-1.342-2.858-4.237-5.594-7.601-5.594-4.637 0-8.4 3.764-8.4 8.401 0 9.433 9.516 11.906 16.001 21.232 6.13-9.268 15.999-12.1 15.999-21.232 0-4.637-3.763-8.401-8.4-8.401z"
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bubble" }, [
          _c("svg", { staticClass: "heart", attrs: { viewBox: "0 0 32 32" } }, [
            _c("title", [_vm._v("heart22")]),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M23.6 2c-3.363 0-6.258 2.736-7.599 5.594-1.342-2.858-4.237-5.594-7.601-5.594-4.637 0-8.4 3.764-8.4 8.401 0 9.433 9.516 11.906 16.001 21.232 6.13-9.268 15.999-12.1 15.999-21.232 0-4.637-3.763-8.401-8.4-8.401z"
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bubble" }, [
          _c("svg", { staticClass: "heart", attrs: { viewBox: "0 0 32 32" } }, [
            _c("title", [_vm._v("heart22")]),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M23.6 2c-3.363 0-6.258 2.736-7.599 5.594-1.342-2.858-4.237-5.594-7.601-5.594-4.637 0-8.4 3.764-8.4 8.401 0 9.433 9.516 11.906 16.001 21.232 6.13-9.268 15.999-12.1 15.999-21.232 0-4.637-3.763-8.401-8.4-8.401z"
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bubble" }, [
          _c("svg", { staticClass: "heart", attrs: { viewBox: "0 0 32 32" } }, [
            _c("title", [_vm._v("heart22")]),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M23.6 2c-3.363 0-6.258 2.736-7.599 5.594-1.342-2.858-4.237-5.594-7.601-5.594-4.637 0-8.4 3.764-8.4 8.401 0 9.433 9.516 11.906 16.001 21.232 6.13-9.268 15.999-12.1 15.999-21.232 0-4.637-3.763-8.401-8.4-8.401z"
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bubble" }, [
          _c("svg", { staticClass: "heart", attrs: { viewBox: "0 0 32 32" } }, [
            _c("title", [_vm._v("heart22")]),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M23.6 2c-3.363 0-6.258 2.736-7.599 5.594-1.342-2.858-4.237-5.594-7.601-5.594-4.637 0-8.4 3.764-8.4 8.401 0 9.433 9.516 11.906 16.001 21.232 6.13-9.268 15.999-12.1 15.999-21.232 0-4.637-3.763-8.401-8.4-8.401z"
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bubble" }, [
          _c("svg", { staticClass: "heart", attrs: { viewBox: "0 0 32 32" } }, [
            _c("title", [_vm._v("heart22")]),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M23.6 2c-3.363 0-6.258 2.736-7.599 5.594-1.342-2.858-4.237-5.594-7.601-5.594-4.637 0-8.4 3.764-8.4 8.401 0 9.433 9.516 11.906 16.001 21.232 6.13-9.268 15.999-12.1 15.999-21.232 0-4.637-3.763-8.401-8.4-8.401z"
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bubble" }, [
          _c("svg", { staticClass: "heart", attrs: { viewBox: "0 0 32 32" } }, [
            _c("title", [_vm._v("heart22")]),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M23.6 2c-3.363 0-6.258 2.736-7.599 5.594-1.342-2.858-4.237-5.594-7.601-5.594-4.637 0-8.4 3.764-8.4 8.401 0 9.433 9.516 11.906 16.001 21.232 6.13-9.268 15.999-12.1 15.999-21.232 0-4.637-3.763-8.401-8.4-8.401z"
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bubble" }, [
          _c("svg", { staticClass: "heart", attrs: { viewBox: "0 0 32 32" } }, [
            _c("title", [_vm._v("heart22")]),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M23.6 2c-3.363 0-6.258 2.736-7.599 5.594-1.342-2.858-4.237-5.594-7.601-5.594-4.637 0-8.4 3.764-8.4 8.401 0 9.433 9.516 11.906 16.001 21.232 6.13-9.268 15.999-12.1 15.999-21.232 0-4.637-3.763-8.401-8.4-8.401z"
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bubble" }, [
          _c("svg", { staticClass: "heart", attrs: { viewBox: "0 0 32 32" } }, [
            _c("title", [_vm._v("heart22")]),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M23.6 2c-3.363 0-6.258 2.736-7.599 5.594-1.342-2.858-4.237-5.594-7.601-5.594-4.637 0-8.4 3.764-8.4 8.401 0 9.433 9.516 11.906 16.001 21.232 6.13-9.268 15.999-12.1 15.999-21.232 0-4.637-3.763-8.401-8.4-8.401z"
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bubble" }, [
          _c("svg", { staticClass: "heart", attrs: { viewBox: "0 0 32 32" } }, [
            _c("title", [_vm._v("heart22")]),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M23.6 2c-3.363 0-6.258 2.736-7.599 5.594-1.342-2.858-4.237-5.594-7.601-5.594-4.637 0-8.4 3.764-8.4 8.401 0 9.433 9.516 11.906 16.001 21.232 6.13-9.268 15.999-12.1 15.999-21.232 0-4.637-3.763-8.401-8.4-8.401z"
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bubble" }, [
          _c("svg", { staticClass: "heart", attrs: { viewBox: "0 0 32 32" } }, [
            _c("title", [_vm._v("heart22")]),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M23.6 2c-3.363 0-6.258 2.736-7.599 5.594-1.342-2.858-4.237-5.594-7.601-5.594-4.637 0-8.4 3.764-8.4 8.401 0 9.433 9.516 11.906 16.001 21.232 6.13-9.268 15.999-12.1 15.999-21.232 0-4.637-3.763-8.401-8.4-8.401z"
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bubble" }, [
          _c("svg", { staticClass: "heart", attrs: { viewBox: "0 0 32 32" } }, [
            _c("title", [_vm._v("heart22")]),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M23.6 2c-3.363 0-6.258 2.736-7.599 5.594-1.342-2.858-4.237-5.594-7.601-5.594-4.637 0-8.4 3.764-8.4 8.401 0 9.433 9.516 11.906 16.001 21.232 6.13-9.268 15.999-12.1 15.999-21.232 0-4.637-3.763-8.401-8.4-8.401z"
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bubble" }, [
          _c("svg", { staticClass: "heart", attrs: { viewBox: "0 0 32 32" } }, [
            _c("title", [_vm._v("heart22")]),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M23.6 2c-3.363 0-6.258 2.736-7.599 5.594-1.342-2.858-4.237-5.594-7.601-5.594-4.637 0-8.4 3.764-8.4 8.401 0 9.433 9.516 11.906 16.001 21.232 6.13-9.268 15.999-12.1 15.999-21.232 0-4.637-3.763-8.401-8.4-8.401z"
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bubble" }, [
          _c("svg", { staticClass: "heart", attrs: { viewBox: "0 0 32 32" } }, [
            _c("title", [_vm._v("heart22")]),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M23.6 2c-3.363 0-6.258 2.736-7.599 5.594-1.342-2.858-4.237-5.594-7.601-5.594-4.637 0-8.4 3.764-8.4 8.401 0 9.433 9.516 11.906 16.001 21.232 6.13-9.268 15.999-12.1 15.999-21.232 0-4.637-3.763-8.401-8.4-8.401z"
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bubble" }, [
          _c("svg", { staticClass: "heart", attrs: { viewBox: "0 0 32 32" } }, [
            _c("title", [_vm._v("heart22")]),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M23.6 2c-3.363 0-6.258 2.736-7.599 5.594-1.342-2.858-4.237-5.594-7.601-5.594-4.637 0-8.4 3.764-8.4 8.401 0 9.433 9.516 11.906 16.001 21.232 6.13-9.268 15.999-12.1 15.999-21.232 0-4.637-3.763-8.401-8.4-8.401z"
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bubble" }, [
          _c("svg", { staticClass: "heart", attrs: { viewBox: "0 0 32 32" } }, [
            _c("title", [_vm._v("heart22")]),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M23.6 2c-3.363 0-6.258 2.736-7.599 5.594-1.342-2.858-4.237-5.594-7.601-5.594-4.637 0-8.4 3.764-8.4 8.401 0 9.433 9.516 11.906 16.001 21.232 6.13-9.268 15.999-12.1 15.999-21.232 0-4.637-3.763-8.401-8.4-8.401z"
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bubble" }, [
          _c("svg", { staticClass: "heart", attrs: { viewBox: "0 0 32 32" } }, [
            _c("title", [_vm._v("heart22")]),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M23.6 2c-3.363 0-6.258 2.736-7.599 5.594-1.342-2.858-4.237-5.594-7.601-5.594-4.637 0-8.4 3.764-8.4 8.401 0 9.433 9.516 11.906 16.001 21.232 6.13-9.268 15.999-12.1 15.999-21.232 0-4.637-3.763-8.401-8.4-8.401z"
              }
            })
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flowers" }, [
      _c("div", { staticClass: "flower flower--1" }, [
        _c("div", { staticClass: "flower__leafs flower__leafs--1" }, [
          _c("div", { staticClass: "flower__leaf flower__leaf--1" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__leaf flower__leaf--2" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__leaf flower__leaf--3" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__leaf flower__leaf--4" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__white-circle" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--1" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--2" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--3" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--4" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--5" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--6" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--7" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--8" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flower__line" }, [
          _c("div", {
            staticClass: "flower__line__leaf flower__line__leaf--1"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__line__leaf flower__line__leaf--2"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__line__leaf flower__line__leaf--3"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__line__leaf flower__line__leaf--4"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__line__leaf flower__line__leaf--5"
          }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__line__leaf flower__line__leaf--6" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flower flower--2" }, [
        _c("div", { staticClass: "flower__leafs flower__leafs--2" }, [
          _c("div", { staticClass: "flower__leaf flower__leaf--1" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__leaf flower__leaf--2" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__leaf flower__leaf--3" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__leaf flower__leaf--4" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__white-circle" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--1" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--2" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--3" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--4" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--5" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--6" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--7" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--8" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flower__line" }, [
          _c("div", {
            staticClass: "flower__line__leaf flower__line__leaf--1"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__line__leaf flower__line__leaf--2"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__line__leaf flower__line__leaf--3"
          }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__line__leaf flower__line__leaf--4" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flower flower--3" }, [
        _c("div", { staticClass: "flower__leafs flower__leafs--3" }, [
          _c("div", { staticClass: "flower__leaf flower__leaf--1" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__leaf flower__leaf--2" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__leaf flower__leaf--3" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__leaf flower__leaf--4" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__white-circle" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--1" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--2" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--3" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--4" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--5" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--6" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--7" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--8" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flower__line" }, [
          _c("div", {
            staticClass: "flower__line__leaf flower__line__leaf--1"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__line__leaf flower__line__leaf--2"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__line__leaf flower__line__leaf--3"
          }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__line__leaf flower__line__leaf--4" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flower flower--4" }, [
        _c("div", { staticClass: "flower__leafs flower__leafs--3" }, [
          _c("div", { staticClass: "flower__leaf flower__leaf--1" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__leaf flower__leaf--2" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__leaf flower__leaf--3" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__leaf flower__leaf--4" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__white-circle" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--1" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--2" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--3" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--4" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--5" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--6" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--7" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__light flower__light--8" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flower__line" }, [
          _c("div", {
            staticClass: "flower__line__leaf flower__line__leaf--1"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__line__leaf flower__line__leaf--2"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__line__leaf flower__line__leaf--3"
          }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__line__leaf flower__line__leaf--4" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "1.2s" } }, [
        _c("div", { staticClass: "flower__g-long" }, [
          _c("div", { staticClass: "flower__g-long__top" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__g-long__bottom" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "growing-grass" }, [
        _c("div", { staticClass: "flower__grass flower__grass--1" }, [
          _c("div", { staticClass: "flower__grass--top" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__grass--bottom" }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__grass__leaf flower__grass__leaf--1"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__grass__leaf flower__grass__leaf--2"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__grass__leaf flower__grass__leaf--3"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__grass__leaf flower__grass__leaf--4"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__grass__leaf flower__grass__leaf--5"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__grass__leaf flower__grass__leaf--6"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__grass__leaf flower__grass__leaf--7"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__grass__leaf flower__grass__leaf--8"
          }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__grass__overlay" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "growing-grass" }, [
        _c("div", { staticClass: "flower__grass flower__grass--2" }, [
          _c("div", { staticClass: "flower__grass--top" }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__grass--bottom" }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__grass__leaf flower__grass__leaf--1"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__grass__leaf flower__grass__leaf--2"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__grass__leaf flower__grass__leaf--3"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__grass__leaf flower__grass__leaf--4"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__grass__leaf flower__grass__leaf--5"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__grass__leaf flower__grass__leaf--6"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__grass__leaf flower__grass__leaf--7"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__grass__leaf flower__grass__leaf--8"
          }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__grass__overlay" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "2.4s" } }, [
        _c("div", { staticClass: "flower__g-right flower__g-right--1" }, [
          _c("div", { staticClass: "leaf" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "2.8s" } }, [
        _c("div", { staticClass: "flower__g-right flower__g-right--2" }, [
          _c("div", { staticClass: "leaf" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "2.8s" } }, [
        _c("div", { staticClass: "flower__g-front" }, [
          _c(
            "div",
            {
              staticClass:
                "flower__g-front__leaf-wrapper flower__g-front__leaf-wrapper--1"
            },
            [_c("div", { staticClass: "flower__g-front__leaf" })]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "flower__g-front__leaf-wrapper flower__g-front__leaf-wrapper--2"
            },
            [_c("div", { staticClass: "flower__g-front__leaf" })]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "flower__g-front__leaf-wrapper flower__g-front__leaf-wrapper--3"
            },
            [_c("div", { staticClass: "flower__g-front__leaf" })]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "flower__g-front__leaf-wrapper flower__g-front__leaf-wrapper--4"
            },
            [_c("div", { staticClass: "flower__g-front__leaf" })]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "flower__g-front__leaf-wrapper flower__g-front__leaf-wrapper--5"
            },
            [_c("div", { staticClass: "flower__g-front__leaf" })]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "flower__g-front__leaf-wrapper flower__g-front__leaf-wrapper--6"
            },
            [_c("div", { staticClass: "flower__g-front__leaf" })]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "flower__g-front__leaf-wrapper flower__g-front__leaf-wrapper--7"
            },
            [_c("div", { staticClass: "flower__g-front__leaf" })]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "flower__g-front__leaf-wrapper flower__g-front__leaf-wrapper--8"
            },
            [_c("div", { staticClass: "flower__g-front__leaf" })]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "flower__g-front__line" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "3.2s" } }, [
        _c("div", { staticClass: "flower__g-fr" }, [
          _c("div", { staticClass: "leaf" }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__g-fr__leaf flower__g-fr__leaf--1"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__g-fr__leaf flower__g-fr__leaf--2"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__g-fr__leaf flower__g-fr__leaf--3"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__g-fr__leaf flower__g-fr__leaf--4"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__g-fr__leaf flower__g-fr__leaf--5"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__g-fr__leaf flower__g-fr__leaf--6"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "flower__g-fr__leaf flower__g-fr__leaf--7"
          }),
          _vm._v(" "),
          _c("div", { staticClass: "flower__g-fr__leaf flower__g-fr__leaf--8" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "long-g long-g--0" }, [
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "3s" } }, [
          _c("div", { staticClass: "leaf leaf--0" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "2.2s" } }, [
          _c("div", { staticClass: "leaf leaf--1" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "3.4s" } }, [
          _c("div", { staticClass: "leaf leaf--2" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "3.6s" } }, [
          _c("div", { staticClass: "leaf leaf--3" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "long-g long-g--1" }, [
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "3.6s" } }, [
          _c("div", { staticClass: "leaf leaf--0" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "3.8s" } }, [
          _c("div", { staticClass: "leaf leaf--1" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "4s" } }, [
          _c("div", { staticClass: "leaf leaf--2" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "4.2s" } }, [
          _c("div", { staticClass: "leaf leaf--3" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "long-g long-g--2" }, [
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "4s" } }, [
          _c("div", { staticClass: "leaf leaf--0" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "4.2s" } }, [
          _c("div", { staticClass: "leaf leaf--1" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "4.4s" } }, [
          _c("div", { staticClass: "leaf leaf--2" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "4.6s" } }, [
          _c("div", { staticClass: "leaf leaf--3" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "long-g long-g--3" }, [
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "4s" } }, [
          _c("div", { staticClass: "leaf leaf--0" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "4.2s" } }, [
          _c("div", { staticClass: "leaf leaf--1" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "3s" } }, [
          _c("div", { staticClass: "leaf leaf--2" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "3.6s" } }, [
          _c("div", { staticClass: "leaf leaf--3" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "long-g long-g--4" }, [
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "4s" } }, [
          _c("div", { staticClass: "leaf leaf--0" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "4.2s" } }, [
          _c("div", { staticClass: "leaf leaf--1" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "3s" } }, [
          _c("div", { staticClass: "leaf leaf--2" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "3.6s" } }, [
          _c("div", { staticClass: "leaf leaf--3" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "long-g long-g--5" }, [
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "4s" } }, [
          _c("div", { staticClass: "leaf leaf--0" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "4.2s" } }, [
          _c("div", { staticClass: "leaf leaf--1" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "3s" } }, [
          _c("div", { staticClass: "leaf leaf--2" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "3.6s" } }, [
          _c("div", { staticClass: "leaf leaf--3" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "long-g long-g--6" }, [
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "4.2s" } }, [
          _c("div", { staticClass: "leaf leaf--0" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "4.4s" } }, [
          _c("div", { staticClass: "leaf leaf--1" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "4.6s" } }, [
          _c("div", { staticClass: "leaf leaf--2" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "4.8s" } }, [
          _c("div", { staticClass: "leaf leaf--3" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "long-g long-g--7" }, [
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "3s" } }, [
          _c("div", { staticClass: "leaf leaf--0" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "3.2s" } }, [
          _c("div", { staticClass: "leaf leaf--1" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "3.5s" } }, [
          _c("div", { staticClass: "leaf leaf--2" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grow-ans", staticStyle: { "--d": "3.6s" } }, [
          _c("div", { staticClass: "leaf leaf--3" })
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d6a32cb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d6a32cb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/varios/components/F1.vue
// module id = null
// module chunks = 